<template>
  <b-card
    no-body
    class="border-0"
    header-class="px-1 py-2 border-bottom-0"
    footer-class="p-1">
    <h6 slot="header" class="mb-0">
      <b-button-close style="font-size: large" class="mx-1" @click="hidePopup()"></b-button-close>
      {{params.colDef.headerName}} filter
    </h6>
    <b-form class="card-text filter">
      <b-input-group size="sm">
        <b-form-input
          v-model="filter"
          type="text"
          placeholder="Enter filter..."
          class="filter">
        </b-form-input>
        <b-input-group-append>
          <b-button
            @click="filter = ''"
            variant="outline-light"
            class="text-secondary"
            style="border: 1px solid #ced4da;">
            <icon icon="times"/>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <b-form-group class="m-1">
        <b-form-checkbox-group
          stacked
          v-model="selected"
          name="listCheckboxes"
          class="filter-checkbox">
          <b-form-checkbox
            v-for="opt in filteredOptions"
            :key="opt"
            :value="opt">
            <div>{{opt}}</div>
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
    </b-form>
    <b-button-toolbar slot="footer">
      <div class="d-flex justify-content-between w-100">
        <b-button-group>
          <b-button size="sm" variant="outline-secondary" class="mr-1" @click="onSelectAll">All</b-button>
          <b-button size="sm" variant="outline-secondary" class="mr-1" @click="onSelectNone">None</b-button>
          <b-button size="sm" variant="outline-secondary" class="mr-1" @click="onSelectInvert">Invert</b-button>
        </b-button-group>
        <b-button-group>
          <b-button size="sm" variant="outline-secondary" class="mr-1" @click="onClearFilter">Clear</b-button>
          <b-button size="sm" variant="secondary" @click="onApplyFilter">Apply</b-button>
        </b-button-group>
      </div>
    </b-button-toolbar>
  </b-card>
</template>

<script>
  import SortedSet from 'collections/sorted-set';

  export default {
    name: 'ListFilter',
    data() {
      return {
        selected: [],
        options: [],
        selectedSet: null,
        params: null,
        hidePopup: null,
        filter: '',
      };
    },
    methods: {
      isFilterActive() {
        return this.selected.length > 0;
      },
      doesFilterPass(params) {
        const {valueGetter} = this.params;
        return this.selected.length === 0 || this.selectedSet.has(valueGetter(params.node));
      },
      getModel() {
        return this.selected;
      },
      setModel(model) {
        this.selected = model || [];
      },
      afterGuiAttached({hidePopup}) {
        this.hidePopup = hidePopup;
      },
      onApplyFilter() {
        this.params.filterChangedCallback();
        this.hidePopup();
      },
      onClearFilter() {
        this.selected = [];
        this.params.filterChangedCallback();
        this.hidePopup();
      },
      onSelectAll() {
        const {filteredOptions, selected} = this;
        this.selected = [...new Set([...selected, ...filteredOptions])];
      },
      onSelectNone() {
        const {filteredOptions, selected} = this;
        const filteredSet = new Set(filteredOptions);
        this.selected = selected.filter(opt => !filteredSet.has(opt));
      },
      onSelectInvert() {
        const {selected, filteredOptions} = this;
        const selectedSet = new Set(selected);
        const filteredSet = new Set(filteredOptions);
        this.selected = [
          ...selected.filter(opt => !filteredSet.has(opt)),
          ...filteredOptions.filter(opt => !selectedSet.has(opt)),
        ];
      },
    },
    computed: {
      filteredOptions() {
        const {options, filter} = this;
        const upperFilter = filter.toUpperCase();
        return options.filter(opt => opt.toUpperCase().indexOf(upperFilter) >= 0);
      },
    },
    watch: {
      selected: {
        handler(selected) {
          this.selectedSet = new Set(selected);
        },
        immediate: true,
      },
    },
    created() {
      const options = new SortedSet();
      const {valueGetter} = this.params;
      this.params.api.forEachNode(node => options.add(valueGetter(node)));
      this.options = [...options.toArray()];
    },
  };
</script>

<style scoped>
  .filter {
    max-height: 200px;
    overflow-y: auto;
    overflow-x: auto;
  }
</style>

<style lang="scss">
  /* fix font size for checkbox */
  .filter-checkbox {
    font-size: 1rem;
    .custom-checkbox {
      min-height: 1rem;
      .custom-control-label div {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .filter {
    input:focus, input:hover, input:active {
      outline: 0 !important;
      -webkit-appearance: none;
      box-shadow: 0 0 0 0 !important;
    }
  }
</style>
